// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorStatus {
  margin: 10% 15%;
}

@media only screen and (max-width: 1024px) {
  .errorStatus {
    padding-top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/system-maintenance/system-maintenance.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EAEI;IACI,iBAAA;EAAN;AACF","sourcesContent":[".errorStatus {\n    margin: 10% 15%;\n}\n\n@media only screen and (max-width: 1024px) {\n\n    .errorStatus {\n        padding-top: 20px\n    }}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
